import { render } from "./PaymentArea.vue?vue&type=template&id=31549e1e"
import script from "./PaymentArea.vue?vue&type=script&lang=js"
export * from "./PaymentArea.vue?vue&type=script&lang=js"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__